<rma-header-count-button
  [title]="'header.tracked' | transloco"
  [count]="trackPropertyService.trackPropertyCount$ | async"
  routerLink="/tracked-properties"
  srSubtitle="properties"
  matIcon="favorite" />
